var IMPORT_PREFIX_PATTERN = /^@import/i;

function isImport(value) {
  return IMPORT_PREFIX_PATTERN.test(value);
}

module.exports = isImport;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/utils/is-import.js
// module id = 620
// module chunks = 0